import { AlertTriangle, Info, XCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { SettlementCheck } from '@services/settlements/types'

import { cn } from '@/lib/utils'

const STYLES = {
  ERROR: {
    icon: XCircle,
    wrapper: 'border-destructive/25 bg-destructive/[0.06]',
    icon_color: 'text-destructive'
  },
  WARNING: {
    icon: AlertTriangle,
    wrapper: 'border-warning/30 bg-peach/30',
    icon_color: 'text-warning'
  },
  INFO: {
    icon: Info,
    wrapper: 'border-info/30 bg-info-soft',
    icon_color: 'text-info'
  }
} as const

export function SettlementCheckBadge({ check }: { check: SettlementCheck }) {
  const { t } = useTranslation('settlement')
  const style = STYLES[check.severity] ?? STYLES.INFO
  const Icon = style.icon

  return (
    <div
      className={cn(
        'flex items-start gap-2.5 rounded-xl border px-3 py-2.5',
        style.wrapper
      )}
    >
      <Icon className={cn('mt-0.5 h-4 w-4 shrink-0', style.icon_color)} />
      <div className="min-w-0">
        <p className="m-0 text-sm text-ink">
          {t(`checks.${check.code}`, {
            ...check.context,
            defaultValue: check.code
          })}
        </p>
      </div>
    </div>
  )
}
